module.exports = __webpack_public_path__ + "static/media/asm1.9c81cd22.jpg";